import type { SvgProps } from '@main/core-ui/src/Icon/constants/enums';
import React from 'react';

export const BannerAndModal: React.FC<SvgProps> = ({ color, size }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 21 20"
    fill="none"
  >
    <path
      d="M10.666 15H19.666"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="10.666"
      y="12"
      width="9"
      height="7"
      rx="2"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66602 7.05469H19.666"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.66602 3.98914L9.66102 3.99414L9.66602 3.99914L9.67102 3.99414L9.66602 3.98914"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.16602 3.98914L7.16102 3.99414L7.16602 3.99914L7.17102 3.99414L7.16602 3.98914"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66602 3.98914L4.66102 3.99414L4.66602 3.99914L4.67102 3.99414L4.66602 3.98914"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.66602 3.98914L9.66102 3.99414L9.66602 3.99914L9.67102 3.99414L9.66602 3.98914"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.16602 3.98914L7.16102 3.99414L7.16602 3.99914L7.17102 3.99414L7.16602 3.98914"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66602 3.98914L4.66102 3.99414L4.66602 3.99914L4.67102 3.99414L4.66602 3.98914"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      // eslint-disable-next-line max-len
      d="M19.666 9V4C19.666 2.34315 18.3229 1 16.666 1H4.66602C3.00916 1 1.66602 2.34315 1.66602 4V16C1.66602 17.6569 3.00916 19 4.66602 19H7.66602"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
